<template>
  <div class="p-lr20 f-14">
    <div class="m-b15 p-10 b-2-gray">
      <el-row class="m-b15">
        <el-col :span="8">开票状态：{{ header.status | convertStatus }}</el-col>
        <el-col :span="8">申请开票时间：{{ header.gmtCreated | dataFormat }}</el-col>
        <el-col :span="8">申请人：{{ header.applyName }}</el-col>
        <el-button
          type="primary"
          class="edit-invoice"
          v-if="!currentState"
          size="medium"
          @click="showInput = true"
          >填写发票信息</el-button
        >
      </el-row>
      <el-row class="m-b15">
        <el-col :span="8">
          <div>买家信息：{{ invoiceVO.invoiceOrgName }}</div>
        </el-col>
        <el-col :span="8">
          <div>开票申请编号：{{ header.invoiceApplyCode }}</div>
        </el-col>
      </el-row>
      <el-row class="m-b15">
        <el-col :span="8">
          <div>开票吨数：{{ header.totalWeight | formatWeightWithUnit }}</div>
        </el-col>
        <el-col :span="8">
          <div>开票金额：{{ header.totalAmount | currencyFormat }}</div>
        </el-col>
      </el-row>
      <el-row class="m-b15">
        <el-col :span="24">
          <div>开票备注：{{ invoiceVO.invoiceRemark | convertEmpty }}</div>
        </el-col>
      </el-row>
      <el-row class="m-b10">
        <el-col :span="24">
          <div>开票说明：{{ invoiceVO.invoiceDesc | convertEmpty }}</div>
        </el-col>
      </el-row>
    </div>

    <div class="b-2-gray m-b20 no-border-bottom">
      <div class="bg-gray p-10 b-2-gray">关联发票信息</div>
      <el-row>
        <el-table :data="invoiceList">
          <el-table-column label="发票代码" prop="invoiceCode" align="center"></el-table-column>
          <el-table-column label="发票号码" prop="invoiceNumber" align="center"></el-table-column>
          <el-table-column label="开票日期" prop="invoiceDate" align="center">
            <template v-slot="{ row }">
              <div>{{ row.invoiceDate | dataFormat('yyyy-MM-dd') }}</div>
            </template>
          </el-table-column>
          <el-table-column label="价税合计金额" align="center">
            <template v-slot="{ row }">
              <span v-if="row.totalTaxAmount">{{ row.totalTaxAmount | currencyFormat }}</span>
              <span v-else>{{ '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额" align="center">
            <template v-slot="{ row }">
              <span v-if="row.invoiceAmount">{{ row.invoiceAmount | currencyFormat }}</span>
              <span v-else>{{ '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="快递单号"
            prop="expressTrackingNum"
            align="center"
          ></el-table-column>
          <el-table-column label="快递公司" align="center">
            <template v-slot="{ row }">
              <span>{{ row.expressCompany || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="查看附件" align="center">
            <template v-slot="{ row }">
              <el-button v-if="row.attachmentFileKey" type="text" @click="handleViewAnnex(row)"
                >查看附件</el-button
              >
              <span v-else>暂无附件</span>
            </template>
          </el-table-column>
          <el-table-column label="快递状态" prop="expressCompany" align="center">
            <template v-slot="{ row }">
              <div class="express-container" v-if="row.id">
                <span
                  class="view-express"
                  @mouseenter="showExpressContainer($event, row.id)"
                  @mouseout="closeExpressContainer"
                  @click="isShowExpressContent = true"
                  >查看物流</span
                >
              </div>
              <div v-else>请保存后查看</div>
            </template>
          </el-table-column>
          <el-table-column label="发票状态" prop="status" align="center">
            <template v-slot="{ row }">
              <div>{{ row.status | convertInvoiceStatus }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="currentState" width="80">
            <template v-slot="{ row }">
              <el-button type="text" @click="abandon(row.id)">废弃</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>

    <div
      class="suspension-express"
      :style="{ top: expressContainerTop + 'px', left: expressContainerLeft + 'px' }"
      v-if="isShowExpressContainer"
    >
      <div v-if="expressInfos[currentExpressId]" class="express-steps">
        <div
          v-for="(step, index) in (expressInfos[currentExpressId] || []).slice(0, 2)"
          :key="index"
        >
          <div class="express-step m-b5" :class="{ 'first-step': index === 0 }">
            <div>{{ step.context }}</div>
            <div class="f-12 m-t5">{{ step.ftime }}</div>
          </div>
        </div>
        <div class="m-t20">查看完整物流信息请点击查看物流</div>
      </div>
      <div v-else>
        <div>获取物流信息失败</div>
      </div>
    </div>

    <el-dialog title="物流详情" :visible.sync="isShowExpressContent">
      <div>
        <span class="m-r10">发票号码：{{ currentInvoice.invoiceNumber }}</span>
        <span class="m-r10">快递单号：{{ currentInvoice.expressTrackingNum }}</span>
        <span>快递公司：{{ currentInvoice.expressCompany }}</span>
      </div>
      <div v-if="expressInfos[currentExpressId]" class="express-content express-steps m-t10">
        <div v-for="(step, index) in expressInfos[currentExpressId] || []" :key="index">
          <div class="express-step m-b5" :class="{ 'first-step': index === 0 }">
            <div>{{ step.context }}</div>
            <div class="f-12 m-t5">{{ step.ftime }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="m-t10">获取物流信息失败</div>
      </div>
    </el-dialog>

    <div class="b-2-gray m-b15">
      <div class="bg-gray p-10 b-2-gray">开票信息</div>
      <div class="p-10">
        <el-row class="m-b15">
          <el-col :span="16"> 采购商：{{ invoiceVO.invoiceOrgName }} </el-col>
        </el-row>
        <el-row class="m-b15">
          <el-col :span="18"> 纳税号：{{ invoiceVO.taxNumber }} </el-col>
        </el-row>
        <el-row class="m-b15">
          <el-col :span="16">开票地址：{{ invoiceVO.invoiceAddress }}</el-col>
          <el-col :span="8">开票电话：{{ invoiceVO.phoneNumber }}</el-col>
        </el-row>
        <el-row class="m-b15">
          <el-col :span="16">开户行：{{ invoiceVO.bankOfDeposit }}</el-col>
          <el-col :span="8">账号：{{ invoiceVO.invoiceAccount }}</el-col>
        </el-row>
        <el-row class="m-b15">
          <el-col :span="16">发票类型：{{ invoiceVO.invoiceType | convertInvoiceType }}</el-col>
          <el-col :span="8">发票单位：吨</el-col>
        </el-row>
        <el-row style="display: flex;flex-wrap: wrap;">
          <el-col
            style="flex-grow: 1;flex-basis: auto; width: unset;line-height: 1.5;"
            class="m-b5"
            :span="16"
            >邮寄地址：{{
              `${expressVO.expressConsignee}，${expressVO.expressPhone}，${fullAddress}`
            }}
          </el-col>
          <el-col :span="8">寄送方式：{{ expressVO.deliveryType | convertDeliveryType }}</el-col>
        </el-row>
      </div>
    </div>

    <div class="b-2-gray m-b50 no-border-bottom">
      <div class="bg-gray p-10 b-2-gray">商品明细</div>
      <el-table :data="goodsList" show-summary :summary-method="summary">
        <el-table-column label="订单编号" prop="bizOrderId" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="viewOrder(row.bizOrderId)">{{
              row.bizOrderId
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="商品" width="250" header-align="center">
          <template v-slot="{ row }">
            <div class="goods-item-container">
              <div class="m-r10 flex flex-ac" v-if="row.itemImg">
                <img :src="row.itemImg | makeImage" class="item-image" />
              </div>
              <div>
                <div class="goods-main-title">{{ row.itemTitle || row.itemSubTitle }}</div>
                <div class="goods-sub-title">{{ row.itemSkuTitle }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="itemPerAmount" align="center" width="100">
          <template v-slot="{ row }">
            <div>
              {{ row.itemPerAmount | formatMoneyCent }} 元/{{
                row.itemWeightUnit | formatWeightUnit
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请开票数量/重量" prop="itemWeight" align="center" width="150">
          <template v-slot="{ row }">
            <div>{{ row.itemSkuQuantity }}件</div>
            <div>{{ row.itemWeight | formatWeightWithUnit }}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请开票金额" prop="invoiceAmount" align="center" width="150">
          <template v-slot="{ row }">
            <div>{{ row.invoiceAmount | currencyFormat }}</div>
          </template>
        </el-table-column>
        <el-table-column label="税额" prop="taxAmount" align="center">
          <template v-slot="{ row }">
            <div>{{ row.taxAmount | currencyFormat }}</div>
          </template>
        </el-table-column>
        <el-table-column label="税率" prop="taxRate" align="center" width="60">
          <template v-slot="{ row }">
            <div>{{ row.taxRate }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" prop="settlementStatus" align="center" width="100">
          <template v-slot="{ row }">
            <div>{{ row.settlementStatus | convertSettlementStatus }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="confirm-buttons" v-if="!currentState">
      <el-button type="primary" @click="saveToDraft">保存为草稿</el-button>
      <el-button type="primary" @click="saveConfirm = true">提交开票</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>

    <el-dialog width="40%" title="提醒" :visible.sync="saveConfirm">
      <div>您确定要提交开票信息吗？</div>
      <template #footer>
        <div>
          <el-button @click="closeCommitConfirm">取消</el-button>
          <el-button type="primary" @click="commit(false)">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog width="40%" title="废弃确认" :visible.sync="showAbandonConfirm">
      <div>您将要废弃该条发票信息，是否重新录入信息？</div>
      <template #footer>
        <div>
          <el-button
            size="medium"
            @click="
              () => {
                showAbandonConfirm = false
                abandonConfirmId = ''
                abandonConfirmInvoice = {}
              }
            "
            >取消</el-button
          >
          <el-button size="medium" type="primary" @click="abandonConfirm">直接废弃</el-button>
          <el-button size="medium" type="primary" @click="edit(abandonConfirmId)"
            >重新录入</el-button
          >
        </div>
      </template>
    </el-dialog>

    <invoice-input
      :visible.sync="showInput"
      :invoice="invoiceList"
      :refresh="doingAbandon"
      @finish="handleInvoiceChange"
      :ignore="this.abandonConfirmId ? [this.abandonConfirmInvoice.invoiceNumber] : []"
    >
    </invoice-input>

    <upload-invoice-dialog ref="viewAnnexDialog" :show-option="false"></upload-invoice-dialog>
  </div>
</template>

<script>
import { currencyFormat } from 'common/filters'
import NP from 'number-precision'

import InvoiceInput from './components/invoice-input'
import UploadInvoiceDialog from './components/uploadInvoiceDialog'

const DEFAULT_HEADER = {
  status: '1',
  gmtCreated: 0,
  applyName: '',
  sellerOrgName: '',
  invoiceApplyCode: '',
  totalWeight: 0,
  totalAmount: 0
}

export default {
  name: 'invoice-detail',
  components: {
    InvoiceInput,
    UploadInvoiceDialog
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created() {
    this.loadData()
  },
  filters: {
    // 开票申请单状态
    convertStatus(status) {
      let statuses = {
        '1': '待开票',
        '2': '已开票'
      }
      return statuses[status] ? statuses[status] : ''
    },
    // 发票类型
    convertInvoiceType(type) {
      let types = {
        '1': '增值税专用发票',
        '2': '增值税普通发票'
      }
      return types[type] ? types[type] : ''
    },
    // 结算单类型
    convertSettlementStatus(status) {
      let statuses = {
        '1': '未结算',
        '2': '已结算'
      }
      return statuses[status] ? statuses[status] : ''
    },
    // 发票寄送方式
    convertDeliveryType(type) {
      let types = {
        '1': '邮寄',
        '2': '自提'
      }
      return types[type] ? types[type] : ''
    },
    // 发票状态（单张）
    convertInvoiceStatus(status) {
      let statuses = {
        '1': '正常',
        '2': '已废弃'
      }
      return statuses[status] ? statuses[status] : ''
    },
    convertEmpty(content) {
      return content ? content : '-'
    }
  },
  data() {
    return {
      header: { ...DEFAULT_HEADER },
      showInput: false,
      showAbandonConfirm: false,
      abandonConfirmId: '',
      abandonConfirmInvoice: {},
      invoiceList: [],
      expressVO: {},
      invoiceVO: {},
      goodsList: [],
      saveConfirm: false,
      doingAbandon: false,
      showCommitConfirm: false,
      expressInfos: {},
      currentExpressId: '',
      isShowExpressContainer: false,
      expressContainerTop: 0,
      expressContainerLeft: 0,
      isShowExpressContent: false
    }
  },
  computed: {
    currentState() {
      return this.header.status === 2
    },
    fullAddress() {
      let { province = '', city = '', area = '', expressAddress = '' } = this.expressVO
      return `${province} ${city} ${area} ${expressAddress}`
    },
    currentInvoice() {
      return this.invoiceList.find(i => i.id === this.currentExpressId) || {}
    }
  },
  methods: {
    async loadData() {
      let { success, data } = await this.$post('invoice.seller.queryInvoiceApplyDetail', {
        request: { invoiceApplyId: Number(this.id) }
      })
      if (success) {
        let content = data[0]
        this.expressVO = { ...content.invoiceExpressVO }
        this.invoiceVO = { ...content.invoiceOrganizationVO }
        Object.keys(this.header).forEach(key => {
          this.header[key] = content[key] ? content[key] : ''
        })
        this.invoiceList = content.invoiceInfoVOS || []
        this.goodsList = content.invoiceApplyItemVOS || []
        this.queryInvoiceExpressByNumbers()
      }
    },
    summary(param) {
      const { columns, data } = param
      return columns.map((item, index) => {
        if (index === 0) return '合计'
        if (item.label !== '申请开票金额' && item.label !== '税额') return '' // 仅合计这两个字段
        return currencyFormat(
          data
            .map(i => i[item.property])
            .reduce((prev, cur) => {
              prev = NP.plus(prev, Number(cur)) // 考虑精度 使用特殊库来操作
              return prev
            }, 0)
        )
      })
    },
    // 加载已关联的发票信息
    loadInvoiceData(id) {
      let { success, data } = this.$post('invoice.queryRelationInvoices', { invoiceApplyId: id })
      if (success) {
        let value = data[0].value.map(i => ({
          id: i.invoiceNumber,
          code: i.invoiceCode,
          billingDate: i.invoiceDate,
          expressCode: i.expressTrackingNum,
          expressCompany: i.expressCompany
        }))
        this.invoiceList = value
      }
    },
    abandon(id) {
      this.abandonConfirmId = id
      this.abandonConfirmInvoice = this.invoiceList.find(i => i.id === id)
      this.showAbandonConfirm = true
    },
    abandonConfirm() {
      this.doingAbandon = true
      this.handleInvoiceChange([])
    },
    edit(id) {
      // 请求该条记录的发票信息并开启编辑器
      this.abandonConfirmId = id
      this.doingAbandon = true
      this.showInput = true
    },
    async handleInvoiceChange(invoiceList) {
      if (this.doingAbandon) {
        let params = {
          id: this.abandonConfirmId,
          invoiceApplyId: this.id,
          invoiceInfo: [...invoiceList]
        }
        let { success, data } = await this.$post('invoice.seller.discardRelationInvoices', {
          request: params
        })
        if (success && data[0].value) {
          this.$message.success('废弃操作已完成')
          this.loadData()
        }
        this.abandonConfirmId = ''
        this.doingAbandon = false
        this.showAbandonConfirm = false
      } else {
        //根据物流单号匹配物流公司
        if (invoiceList.length > 0) {
          const numbersList = invoiceList.map(ele => ele.expressTrackingNum)
          let { success, data } = await this.$get('invoice.common.queryBatchExpressInfo', {
            request: { numbersList }
          })
          if (success && data[0].expressVOList) {
            data[0].expressVOList.forEach(ele => {
              invoiceList.forEach(item => {
                if (ele.numbers == item.expressTrackingNum) {
                  item.expressCompany = ele.name
                }
              })
            })
          }
          this.invoiceList = [...invoiceList]
        }
      }
      this.showInput = false
    },
    async saveToDraft() {
      await this.commit(true)
    },
    async commit(draft = false) {
      // 当 draft 为 true 的时候保存到草稿
      let params = {
        invoiceApplyId: Number(this.id),
        isInvoiced: !draft,
        invoiceInfo: this.invoiceList
      }
      if (!draft && this.invoiceList.length < 1) {
        this.$message.warning('您没有添加关联发票，不能提交开票。请关联发票后再试。')
        return false
      }
      let { success, data } = await this.$post('invoice.seller.relationInvoices', {
        request: params
      })
      if (success) {
        if (data[0].value && !draft) {
          this.$message.success('开票已完成！')
        } else if (!data[0].value) {
          this.$message.error('开票信息保存失败')
        } else if (data[0].value && draft) {
          this.$message.success('开票信息已保存。')
        }
      }
      this.closeCommitConfirm()
      this.loadData()
    },
    closeCommitConfirm() {
      this.saveConfirm = false
    },
    cancel() {
      this.$router.back()
    },
    viewOrder(id) {
      this.$router.push({ path: '/order/detail/' + id })
    },
    async queryInvoiceExpressByNumbers() {
      if (this.invoiceList.length === 0) return
      const numbersList = this.invoiceList.map(ele => ele.expressTrackingNum)
      let { success, data } = await this.$get('invoice.common.queryBatchExpressInfo', {
        request: { numbersList }
      })
      if (success && data[0].expressVOList) {
        data[0].expressVOList.forEach(res => {
          this.invoiceList.forEach(item => {
            if (res.numbers === item.expressTrackingNum) {
              this.$set(item, 'expressCompany', res.name)
              this.$set(this.expressInfos, item.id, res.expressDetailVOList)
            }
          })
        })
      }
    },
    async queryInvoiceExpressById(id) {
      if (!id) return
      const { success, data } = await this.$post('invoice.common.queryExpressInfo', {
        request: {
          invoiceId: id
        }
      })
      if (success && data[0]) {
        const item = this.invoiceList.find(ele => ele.id === id)
        if (item && data[0].name) {
          this.$set(item, 'expressCompany', data[0].name)
        }
        if (data[0].expressDetailVOList) {
          this.$set(this.expressInfos, id, data[0].expressDetailVOList)
        }
      }
    },
    closeExpressContainer() {
      this.isShowExpressContainer = false
    },
    async showExpressContainer({ clientX, clientY }, id) {
      if (this.currentExpressId !== id && !this.expressInfos[id] && !this.isShowExpressContainer) {
        this.queryInvoiceExpressById(id)
      }
      if (!this.isShowExpressContainer) {
        this.isShowExpressContainer = true
        this.expressContainerTop = clientY + 10
        this.expressContainerLeft = clientX - 250 - 10
        this.currentExpressId = id
      }
    },
    handleViewAnnex(data) {
      this.$refs.viewAnnexDialog.visible = true
      this.$refs.viewAnnexDialog.fileList =
        data.attachmentFileKey &&
        data.attachmentFileKey.map(x => ({
          ...x,
          fk: x.fileKey
        }))
    }
  }
}
</script>

<style lang="stylus" scoped>
.confirm-buttons {
  display: flex;
  width: 250px;
  margin: 0 auto;
  justify-content: space-between;
  flex-shrink: 0;
}

.goods-main-title {
  color: #333333;
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
}

.goods-sub-title {
  color: #999999;
  font-size: 12px;
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
}

.edit-invoice {
  position: absolute;
  right: 0;
  top: 0;
}

.item-image {
  width: 50px;
  height @width
  object-fit contain
}

.suspension-express
  position fixed
  background white
  border 1px #ccc solid
  padding 10px
  padding-left 30px
  width 280px
  word-break break-all
  line-height 1.5
  z-index 100
.express-content
  line-height 1.5
  margin-left 10px
.express-step
  position relative
  &:before
    content ''
    height 5px
    width @height
    border-radius 10px
    background #ccc
    position absolute
    top 7px
    left -15px
.first-step:before
  background #cd974c
.express-container
  position relative
.view-express
  color #cd974c
  text-decoration underline
  cursor pointer


.goods-item-container
  display flex
  align-items center
.no-border-bottom
  border-bottom none
</style>
